export const moveOrgArrayElement = (indexTo, org_id, arr) => {
  if (indexTo >= arr.length || indexTo < 0) {
    return;
  }

  const indexFrom = arr.findIndex((item) => item.id === org_id);

  if (indexFrom !== -1) {
    const elementToMove = arr.splice(indexFrom, 1)[0];
    arr.splice(indexTo, 0, elementToMove);
  }
};
